import BackofficeController from "backoffice_controller";

export default class extends BackofficeController {
  static targets = [
    "accessibleInput",
    "nonAccessibleInput",
    "undefinedInput",
    "accessibleBtn",
    "nonAccessibleBtn",
    "undefinedBtn",
    "openInput",
    "closeInput",
    "notSpecifiedInput",
    "openBtn",
    "closeBtn",
    "notSpecifiedBtn"
  ];

  connect() {
    this.initRadioBtn();
  }

  initRadioBtn() {
    // ACCESSIBILITY CASE
    if (this.hasAccessibleInputTarget) {
      this.targetsConfig = [
        {
          input: this.accessibleInputTarget,
          button: this.accessibleBtnTarget
        },
        {
          input: this.nonAccessibleInputTarget,
          button: this.nonAccessibleBtnTarget
        },
        {
          button: this.undefinedBtnTarget
        }
      ];
    }

    // SCHEDULES CASE
    if (this.hasOpenInputTarget) {
      this.targetsConfig = [
        {
          input: this.openInputTarget,
          button: this.openBtnTarget
        },
        {
          input: this.closeInputTarget,
          button: this.closeBtnTarget
        },
        {
          input: this.notSpecifiedInputTarget,
          button: this.notSpecifiedBtnTarget
        }
      ];
    }

    this.checkRadios();
  }

  handleClick(event) {
    event.preventDefault();
    this.resetBtnStyle();
    const status = event.currentTarget.dataset.status;
    let toActivate = 0;

    if (status === "accessible" || status === "open") {
      toActivate = 0;
    } else if (status === "nonAccessible" || status === "close") {
      toActivate = 1;
    } else {
      toActivate = 2;
    }

    this.targetsConfig[toActivate].input.checked = true;
    if (toActivate === 0 || toActivate === 1) {
      this.styleBtn(this.targetsConfig[toActivate].button, "active");
    } else {
      this.styleBtn(this.targetsConfig[toActivate].button, "default");
    }

    // if (status === "open" || status === "close" || status === "not_specified") {
    //   this.timerangeCtrl = this.getControllerByIdentifier("bo-time-range-field");
    //   this.timerangeCtrl.handleTimeRangeTypeChange(status, this.element);
    // }
  }

  checkRadios() {
    if (this.targetsConfig[0].input.checked) {
      this.styleBtn(this.targetsConfig[0].button, "active");
    } else if (this.targetsConfig[1].input.checked) {
      this.styleBtn(this.targetsConfig[1].button, "active");
    } else {
      this.styleBtn(this.targetsConfig[2].button, "default");
    }
  }

  styleBtn(element, className) {
    element.classList.add(className);
  }

  resetBtnStyle() {
    this.targetsConfig[0].button.classList.remove("active");
    this.targetsConfig[1].button.classList.remove("active");
    this.targetsConfig[2].button.classList.remove("default");
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }
}
